export default __webpack_public_path__ + "static/media/mobileLogo.e508ac22.svg";